import { useMemo } from "react";
import parlors from "@/constants/parlors_detail.json";
import { FUNERAL_SIGUNGU } from "goi_common";

export const useParlorCompareEstimate = ({
  isDetail,
  isLargeCity,
  sido,
  sigungu,
}: {
  isDetail: boolean;
  isLargeCity: boolean;
  sido: string;
  sigungu: string;
}) => {
  const comparedParlors = useMemo(() => {
    if (isLargeCity) {
      return parlors.filter((p) => p.sido === sido);
    } else {
      return parlors.filter((p) => p.sigungu === sigungu);
    }
  }, [isLargeCity]);

  const estimates = useMemo(() => {
    if (comparedParlors) {
      const estimatedParlors = comparedParlors
        .sort((a, b) => a.expected_charge_sum["일반장"] - b.expected_charge_sum["일반장"])
        .slice(0, 4)
        .map((p, index) => {
          if (index === 0) {
            return {
              id: p.id,
              name: "55세 남성",
              tag: "조문객 200명",
              suggestion:
                FUNERAL_SIGUNGU.get(Number(p.sido))?.get(Number(p.sigungu)) +
                " " +
                Math.floor(
                  (p.expected_charge_sum["일반장"] + 3_590_000) / 10_000,
                ).toLocaleString() +
                "만원(OOOO장례식장)",
            };
          } else if (index === 1) {
            return {
              id: p.id,
              name: "조OO",
              tag: "무빈소",
              suggestion:
                Math.floor(
                  (p.expected_charge_sum["무빈소"] + 1_590_000) / 10_000,
                ).toLocaleString() + "만원(제휴 장례식장)",
            };
          } else if (index === 2) {
            return {
              id: p.id,
              name: "조OO",
              tag: "조문객 50명",
              suggestion: "저렴한 장례식장, 접근성 좋은 곳",
            };
          } else if (index === 3) {
            return {
              id: p.id,
              name: "김OO",
              tag: "조문객 100명",
              suggestion: p.companyname,
            };
          } else {
            return {};
          }
        });
      return {
        answered: [estimatedParlors[0], estimatedParlors[1]].filter((i) => i),
        waiting: [estimatedParlors[2], estimatedParlors[3]].filter((i) => i),
      };
    } else {
      return {};
    }
  }, [comparedParlors]);

  const LAST_NAMES = [
    ["김", "손", "송"],
    ["이", "신", "노"],
    ["박", "안", "한"],
    ["최", "강", "임"],
  ];

  const 김해전문장례식장_조문객_100명_가격들 = [839, 840, 841];
  const 천안지역_무빈소_최저가격들 = [237, 238, 239];

  const randomZero = Math.floor((Math.random() * 10) / 4);
  const randomOne = Math.floor((Math.random() * 10) / 4);
  const randomTwo = Math.floor((Math.random() * 10) / 4);
  const randomThree = Math.floor((Math.random() * 10) / 4);

  const DEFAULT_ESTIMATES = {
    answered: [
      {
        id: 1,
        name: `${LAST_NAMES[0][randomZero]}OO`,
        tag: "조문객 100명",
        suggestion: `김해전문장례식장 ${김해전문장례식장_조문객_100명_가격들[randomZero]}만원`,
      },
      {
        id: 2,
        name: `${LAST_NAMES[1][randomOne]}OO`,
        tag: "무빈소",
        suggestion: `천안지역 최저가 ${천안지역_무빈소_최저가격들[randomOne]}만원`,
      },
    ],
    waiting: [
      {
        id: 3,
        name: `${LAST_NAMES[2][randomTwo]}OO`,
        tag: "조문객 50명",
        suggestion: "대구, 대학병원급 쾌적한 시설",
      },
      {
        id: 4,
        name: `${LAST_NAMES[3][randomThree]}OO`,
        tag: "조문객 200명",
        suggestion: "교원예움 서서울장례식장",
      },
    ],
  };
  return {
    estimates: isDetail ? estimates : DEFAULT_ESTIMATES,
  };
};
